import {
  setValueToLocalStorage,
  getValueFromLocalStorage,
  removeValueFromLocalStorage,
} from './localStorage'

import { ThemeFlag } from '@store/theme'

export const setThemeToStorage = (theme: ThemeFlag) => {
  setValueToLocalStorage('theme', theme)
}

export const getThemeFromStorage = () => {
  return getValueFromLocalStorage('theme')
}

export const setAccessTokenToStorage = (token: Token) => {
  setValueToLocalStorage('token', token)
}

export const getAccessTokenFromStorage = () => {
  return getValueFromLocalStorage('token')
}

export const removeTokenFromStorage = () => {
  removeValueFromLocalStorage('token')
}
